<template>
  <transition name="rm-fade">
    <aside v-if="visible" class="rm" role="dialog" aria-label="Indicar um colega">
      <button type="button" class="rm-close" title="Agora não" @click="dismiss">✕</button>
      <p class="rm-title">✨ Isso te poupou tempo?</p>
      <p class="rm-text">
        Mande para um colega que ainda escreve prontuário à mão. Pelo seu link ele ganha <b>30 dias com tudo liberado</b> e você
        ganha <b>1 mês grátis</b> quando ele começar a usar.
      </p>
      <div class="rm-actions">
        <a class="rm-wa" :href="whatsappUrl" target="_blank" rel="noopener" @click="shared('whatsapp')">Enviar no WhatsApp</a>
        <button type="button" class="rm-sec" @click="copy">{{ copied ? "Copiado!" : "Copiar link" }}</button>
      </div>
    </aside>
  </transition>
</template>

<script>
import { canNudge, claimNudge } from "@/utils/nudges";
import { track } from "@/utils/analytics";

// Asks for a referral right after a moment of value (the AI organizing a note),
// from the 2nd such moment on, at most once every 3 weeks and never again after 3 "not now".
const KEY = "ordexa/referral-moment";
const EVERY_MS = 21 * 24 * 3600 * 1000;

function load() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch (e) {
    return {};
  }
}
function save(state) {
  try {
    localStorage.setItem(KEY, JSON.stringify(state));
  } catch (e) {
    /* private mode: just skip */
  }
}

export default {
  name: "ComponentReferralMoment",
  data() {
    return { visible: false, copied: false, source: "" };
  },
  computed: {
    company() {
      return this.$store.state.Companies.company || {};
    },
    url() {
      const code = this.company.referral_code;
      return code ? `https://ordexa.com.br/?ref=${code}&utm_source=indicacao&utm_medium=referral&utm_content=${this.source || "momento"}` : null;
    },
    message() {
      return (
        "Estou usando o Ordexa no consultório: gravo ou dito a sessão e a IA escreve a anotação no formato de prontuário, eu só reviso. " +
        `Pelo meu link você ganha 30 dias com tudo liberado, sem cartão: ${this.url}`
      );
    },
    whatsappUrl() {
      return `https://wa.me/?text=${encodeURIComponent(this.message)}`;
    },
  },
  mounted() {
    this.$eventbus.on("Referral/moment", this.onMoment);
  },
  beforeUnmount() {
    this.$eventbus.off("Referral/moment", this.onMoment);
  },
  methods: {
    onMoment(payload = {}) {
      const state = load();
      state.count = (state.count || 0) + 1;
      save(state);
      if (!this.url || state.count < 2 || (state.dismissed || 0) >= 3) return;
      if (state.lastShown && Date.now() - state.lastShown < EVERY_MS) return;
      if (!canNudge()) return;
      this.source = payload.source || "momento";
      // Let the toast of the action show first (and a milestone, which wins the day).
      setTimeout(() => {
        if (!claimNudge()) return;
        state.lastShown = Date.now();
        save(state);
        this.visible = true;
        track("referral_moment_shown", { source: this.source });
      }, 4000);
    },
    shared(channel) {
      track("referral_share", { channel, from: `moment_${this.source}` });
      setTimeout(() => (this.visible = false), 400);
    },
    async copy() {
      try {
        await navigator.clipboard.writeText(this.message);
      } catch (e) {
        window.prompt("Copie e envie:", this.message);
      }
      this.copied = true;
      this.shared("copy");
    },
    dismiss() {
      const state = load();
      state.dismissed = (state.dismissed || 0) + 1;
      save(state);
      track("referral_moment_dismissed", { source: this.source });
      this.visible = false;
    },
  },
};
</script>

<style scoped>
.rm { position: fixed; right: 20px; bottom: 20px; z-index: 900; width: 340px; max-width: calc(100vw - 32px); background: #fff; border-radius: 14px; box-shadow: 0 16px 40px rgba(16, 42, 51, 0.25); padding: 16px 18px; border: 1.5px solid #b9e4ee; }
.rm-close { position: absolute; top: 8px; right: 10px; background: none; border: none; font-size: 1.05em; color: #7d8d92; cursor: pointer; }
.rm-title { margin: 0 0 6px; font-weight: 700; color: #1d2b2f; }
.rm-text { margin: 0 0 12px; color: #3d5056; font-size: 0.92em; line-height: 1.45; }
.rm-actions { display: flex; gap: 8px; flex-wrap: wrap; }
.rm-wa { background: #1f9d55; color: #fff; border-radius: 10px; padding: 0.55em 1em; font-weight: 700; text-decoration: none; }
.rm-sec { background: #fff; border: 1.5px solid #9fd3df; color: #127a8f; border-radius: 10px; padding: 0.5em 1em; font-weight: 600; cursor: pointer; font: inherit; }
.rm-fade-enter-active, .rm-fade-leave-active { transition: opacity 0.2s, transform 0.2s; }
.rm-fade-enter-from, .rm-fade-leave-to { opacity: 0; transform: translateY(10px); }
@media (max-width: 640px) { .rm { right: 16px; left: 16px; bottom: 16px; width: auto; } }
</style>
